import { Icon } from "@/components/atoms";
import { VehicleDetailCard } from "../common/VehicleDetailCard";
import { useViewVehicleContext } from "../context";

export const VehicleCategoryDetailCard = () => {
  const { vehicle } = useViewVehicleContext();

  const Tooltip = (
    <div className="max-w-[295px] font-medium normal-case">
      RideMinder&apos;s system category used for matching vehicles to network jobs
    </div>
  );

  return (
    <VehicleDetailCard
      icon={<Icon name="Car" size="xl" className="text-neutral-black" />}
      title="Vehicle Category"
      description={vehicle.vehicleCategory?.name ?? "-"}
      tooltip={Tooltip}
    />
  );
};
